import type { Role } from "@/lib/users.api";

export type UsersPageViewMode = "table" | "grid";

export const USERS_PAGE_GUIDE = [
  "« Nouvel utilisateur » crée le compte, puis la personne l'active elle-même par OTP à sa première connexion.",
  "Seul un super_admin peut gérer les comptes admin ou super_admin.",
];

export const USERS_PAGE_TIP =
  "Désactiver un compte ne supprime jamais son historique d'actions.";

export const USERS_PAGE_INTRO =
  "Comptes internes de l'agence, rôles d'accès et suivi d'activité par employé.";

export const USER_ROLE_FILTER_OPTIONS: Array<{ value: Role; label: string }> = [
  { value: "agent", label: "Agent" },
  { value: "manager", label: "Manager" },
  { value: "admin", label: "Admin" },
  { value: "super_admin", label: "Super Admin" },
  { value: "consultant", label: "Consultant" },
  { value: "dev", label: "Dev / Supervision" },
];
